<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('placeOrder.BatchExport')"
    :visible.sync="dialogVisibleExport"
    top="10vh"
    width="600px"
    class="export_dialog"
    @close="clearForm"
  >
    <el-form
      ref="exportRuleForm"
      :model="exportRuleForm"
      class="demo-exportRuleForm"
      label-position="top"
    >
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        }"
        prop="NumberType"
        :label="$t('orderCenterCont.trackingNumberType')"
      >
        <el-select
          v-model="exportRuleForm.NumberType"
          style="width: 80%"
          @change="handleNumberTypeChange"
        >
          <!--安骏运单号-->
          <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
          <!--扫描单号-->
          <el-option key="6" :label="$t('GlobalSetObj.ScanNumber')" :value="6" />
          <!--服务商单号-->
          <el-option key="2" :label="$t('GlobalSetObj.serviceLogistics')" :value="2" />
          <!--客户订单号-->
          <el-option key="3" :label="$t('newOrder.PlatformOrderNumber')" :value="3" />
          <!--中转仓袋号-->
          <el-option key="4" :label="$t('orderCenterCont.TransitBinBagNumber')" :value="4" />
          <!--子包号-->
          <el-option key="5" :label="$t('orderCenterCont.SubpackageNumber')" :value="5" />
          <!--派送路线-->
          <!--          <el-option key="6" :label="$t('newOrder.InvoiceNumber')" value="6" />-->
        </el-select>
      </el-form-item>
      <el-form-item
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="inputValeu"
        :label="$t('orderCenterCont.trackingNumberList')"
        style="width: 100%"
      >
        <el-input
          v-model="exportRuleForm.inputValeu"
          :placeholder="$t('orderCenterCont.Multiple')"
          clearable
          rows="6"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <span class="export_ctt">{{ $t('orderCenterCont.exportContent') }}</span><!-- 导出内容 -->
    <el-row type="flex" class="export_radio">
      <el-col :span="8">
        <el-radio v-model="radio" label="1" border>{{ $t('GlobalSetObj.ExportingList') }}</el-radio><!-- 导出列表信息 -->
      </el-col>
      <el-col :span="8">
        <el-radio v-model="radio" label="2" border>{{ $t('GlobalSetObj.ExportReceipt') }}</el-radio><!-- 导出签收信息 -->
      </el-col>
      <el-col :span="8">
        <el-radio v-model="radio" label="3" border>{{ $t('GlobalSetObj.ExportSubPackage') }}</el-radio><!-- 导出子包信息 -->
      </el-col>
      <el-col :span="8">
        <el-radio
          v-model="radio" :disabled="secondLatestTrackRadioDisabled" label="4"
          border
        >
          {{ $t('GlobalSetObj.ExportSecondLatestTrack') }}<!-- 次新轨迹导出 -->
        </el-radio>
      </el-col>
      <el-col :span="8">
        <el-radio v-model="radio" label="5" border>
          {{ $t('GlobalSetObj.crossBorderInvoiceInfo') }}<!-- 跨境发票信息 -->
        </el-radio>
      </el-col>
      <el-col :span="8">
        <el-radio v-model="radio" label="6" border>
          {{ $t('driver.exportProductInfo') }}<!-- 导出商品信息 -->
        </el-radio>
      </el-col>
      <el-col :span="24">
        <el-radio v-model="radio" label="7" border>
          <!-- 导出操作和轨迹时间 -->
          <i class="el-icon-time export_radio_icon" />{{ $t('collectionCenter.exportActionsAndTimeline') }}
        </el-radio>
      </el-col>
    </el-row>
    <div v-if="radio === '7'">
      <el-collapse v-model="collapseVal" class="export_collapse">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="export_collapse_title">
              <svg-icon icon-class="arrowWaveLine" />
              {{ $t('collectionCenter.selectTimeNode') }}<!-- 请选择时间节点... -->
            </div>
          </template>

          <div class="collapse-content">
            <!-- 全选选项框 -->
            <div class="export_checkAll">
              <el-checkbox
                v-model="consistencySelectAll"
                @change="handleSelectAll($event)"
              >
                {{ $t('collectionCenter.allSelect') }}
              </el-checkbox>
              <span class="export_checkAll_total">
                {{ $t('collectionCenter.totalEightNodes1') }}<!-- 共 -->
                {{ collapseTotal }}
                {{ $t('collectionCenter.totalEightNodes2') }}<!-- 个节点 -->
              </span>
            </div>
            <div
              v-for="(item, index) in consistencyList"
              :key="index"
              class="export_time_item"
            >
              <div class="export_time_item_type">
                <svg-icon :icon-class="item.icon" /><span>{{ item.name }}</span>
              </div>
              <div class="export_time_item_time">
                <el-checkbox
                  v-model="item.timeDesc[0].checked"
                >
                  <div>
                    <span class="export_time_opera_type green">{{ $t('collectionCenter.operation') }}</span>
                    <span>{{ item.timeDesc[0].timeName }}</span>
                  </div>
                </el-checkbox>
              </div>
              <div class="export_time_item_time">
                <el-checkbox
                  v-model="item.timeDesc[1].checked"
                >
                  <div>
                    <span class="export_time_opera_type blue">{{ $t('collectionCenter.trackingPackage') }}</span>
                    <span>{{ item.timeDesc[1].timeName }}</span>
                  </div>
                </el-checkbox>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div style="text-align: right; margin: 15px 0">
      <el-button
        size="small" @click="dialogVisibleExport = false"
      >{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button
        size="small" type="success" class="el-icon-download"
        @click="comfire"
      > {{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  batchNumberExport,
  exportList,
  exportPackageInfo,
  exportSecondLatestTrack,
  exportSignInfo,
  exportTfkInfo,
  operationTrackTime
} from '@/api/logisticsOrders';
import { goRWExportList } from '@/utils/goExportList';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      collapseTotal: 0,
      collapseVal: '1',
      consistencyList: [
        {
          icon: 'package',
          name: this.$t('collectionCenter.collect'), // '揽收'
          // 揽收操作时间、揽收轨迹时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType1'), typeVal: 1, checked: false },
            { timeName: this.$t('collectionCenter.timeType2'), typeVal: 2, checked: false }
          ]
        },
        {
          icon: 'warehouse',
          name: this.$t('collectionCenter.networkEntry'), // '网点入库'
          // 网点入库操作时间、网点入库轨迹时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType3'), typeVal: 3, checked: false },
            { timeName: this.$t('collectionCenter.timeType4'), typeVal: 4, checked: false }
          ]
        },
        {
          icon: 'motorcycle',
          name: this.$t('collectionCenter.branchDelivery'), // '网点派件'
          // 网点派件操作时间、网点派件轨迹时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType5'), typeVal: 5, checked: false },
            { timeName: this.$t('collectionCenter.timeType6'), typeVal: 6, checked: false }
          ]
        },
        {
          icon: 'form',
          name: this.$t('GlobalSetObj.zhengxiang'), // '正向签收'
          // 正向签收操作时间、正向签收轨迹产生时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType7'), typeVal: 7, checked: false },
            { timeName: this.$t('collectionCenter.timeType8'), typeVal: 8, checked: false }
          ]
        },
        {
          icon: 'Failed',
          name: this.$t('collectionCenter.deliveryFailed'), // '派送失败'
          // 派送失败操作时间、派送失败轨迹时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType9'), typeVal: 9, checked: false },
            { timeName: this.$t('collectionCenter.timeType10'), typeVal: 10, checked: false }
          ]
        },
        {
          icon: 'returnCenter',
          name: this.$t('GlobalSetObj.TheReturnComplete'), // '退件签收'
          // 退件签收操作时间、退件签收轨迹时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType11'), typeVal: 11, checked: false },
            { timeName: this.$t('collectionCenter.timeType12'), typeVal: 12, checked: false }
          ]
        },
        {
          icon: 'sorting',
          name: this.$t('collectionCenter.finalStatus'), // '终态'
          // 终态操作时间、终态轨迹时间
          timeDesc: [
            { timeName: this.$t('collectionCenter.timeType13'), typeVal: 13, checked: false },
            { timeName: this.$t('collectionCenter.timeType14'), typeVal: 14, checked: false }
          ]
        }
      ],
      dialogVisibleExport: false,
      exportRuleForm: {
        NumberType: 1,
        inputValeu: ''
      },
      radio: '1',
      // 用于控制“次新轨迹导出” radio 的启用/禁用
      secondLatestTrackRadioDisabled: false
    };
  },
  computed: {
    consistencySelectAll: {
      get() {
        return this.consistencyList.every(item =>
          item.timeDesc.every(time => time.checked)
        );
      },
      set(value) {
        this.consistencyList.forEach(item => {
          item.timeDesc.forEach(time => {
            time.checked = value;
          });
        });
      }
    }
  },
  watch: {
    radio(val) {
      if (val !== '7') {
        this.handleSelectAll(false);
      }
    }
  },
  methods: {
    handleSelectAll(checked) {
      this.consistencyList.forEach(item => {
        item.timeDesc.forEach(time => {
          time.checked = checked;
        });
      });
    },
    handleOpen() {
      this.dialogVisibleExport = true;
      this.radio = '1';
      this.collapseTotal = this.consistencyList.reduce((total, item) => {
        return total + (item.timeDesc ? item.timeDesc.length : 0);
      }, 0);
      this.handleSelectAll(false);
    },
    clearForm() {
      console.log('clearForm');
      this.exportRuleForm.NumberType = 1;
      this.secondLatestTrackRadioDisabled = false;
      this.exportRuleForm.inputValeu = '';
    },
    // 处理单号类型切换
    handleNumberTypeChange(value) {
      if (value !== 1) {
        this.secondLatestTrackRadioDisabled = true;
        if (this.radio === '4') {
          this.radio = '1';
        }
      } else {
        this.secondLatestTrackRadioDisabled = false;
      }
    },
    comfire() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const numberList = this.exportRuleForm.inputValeu
            ? this.exportRuleForm.inputValeu.split('\n')
            : [];
          const numList = numberList.filter((item) => item !== '');
          if (numList.length > 100000) {
            this.$message.error(this.$t('GlobalSetObj.notMore10w'));
            return;
          }
          const param = {
            numberType: this.exportRuleForm.NumberType,
            numberList: numList
          };
          if (this.radio === '1') {
            // 导出列表信息
            exportList(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '2') {
            // 导出签收信息
            exportSignInfo(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '3') {
            // 导出子包信息
            exportPackageInfo(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '4') {
            // 次新轨迹导出
            exportSecondLatestTrack(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '5') {
            // 跨境发票信息
            exportTfkInfo(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '6') {
            // 支持导出订单商品信息
            batchNumberExport(param).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          } else if (this.radio === '7') {
            // 导出操作和轨迹时间
            const timeNodeList = this.consistencyList
              .filter(item => item.timeDesc)
              .flatMap(item => item.timeDesc.filter(time => time.checked).map(time => time.typeVal));
            const paramSeven = {
              numberType: this.exportRuleForm.NumberType,
              numberList: numList,
              timeNodeList
            };
            if (timeNodeList.length <= 0) {
              this.$message.error(this.$t('collectionCenter.selectTimeNode'));
              return;
            }
            operationTrackTime(paramSeven).then((res) => {
              if (res.code === 200) {
                this.dialogVisibleExport = false;
                goRWExportList(this);
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.export_dialog >>> .el-dialog .el-dialog__body { max-height: 700px;overflow-y: auto; }
.export_ctt { line-height: 28px;font-size: 14px;color: #606266;font-weight: 700; }
.export_radio { justify-content: space-between;align-items: center;flex-wrap: wrap;gap: 5px;margin-top: 10px; }
.export_radio >>> .el-col { flex: 1; }
.export_radio >>> .el-col .el-radio { width: 100%;border-radius: 10px;background: #f4f3eb;box-sizing: border-box; }
.export_radio >>> .el-col .el-radio.is-checked { background: #e9fbf6;color: #00a36e;font-weight: bold;border-color: #04b183; }
.export_radio >>> .el-col .el-radio.is-checked .el-radio__label { color: #00a36e; }
.export_radio >>> .el-col .el-radio__input.is-checked .el-radio__inner { border-color: #00a36e;background: #00a36e; }
.export_radio_icon { margin-right: 10px; }
.export_collapse { margin-top: 5px;margin-bottom: 20px; border: 1px solid #00a36e; border-radius: 10px;overflow: hidden}
.export_collapse >>> .el-collapse-item__wrap { background-color: transparent !important; border: none; }
.export_collapse >>> .el-collapse-item { border-radius: 10px; }
.export_collapse >>> .el-collapse-item__header {
  border-top-left-radius: 10px;border-top-right-radius: 10px;border-bottom-color: #92ecd6;
  background-color: #f4fcf9;height: 40px !important;line-height: 40px !important;
  padding: 0 10px;box-sizing: border-box;
  color: #04b083;
}
.export_collapse_title { color: #afafae;font-style: italic;letter-spacing: 1px; }
.export_collapse_title >>> .svg-icon { overflow: unset;margin-right: 5px; }
.export_checkAll { padding: 5px 10px;display: flex;justify-content: space-between;align-items: center; }
.export_checkAll >>> .el-checkbox__label { color: black; font-weight: bold; }
.export_checkAll .export_checkAll_total { font-weight: normal;color: #818179; }
.export_time_item { padding: 8px 10px;border-top: 1px solid #e4e4e4; box-sizing: border-box }
.export_time_item_type { color: #7a7970;font-weight: bold; font-size: 13px; }
.export_time_item_type >>> .svg-icon { font-size: 11px;margin-right: 5px; }
.export_time_item_time { margin-top: 10px;margin-left: 17px;color: #565654;font-size: 14px; }
.export_time_opera_type { border-radius: 2px;padding: 2px 4px;box-sizing: border-box;font-size: 12px;margin-right: 10px; }
.export_time_opera_type.green { color: #288410;background-color: #e6f2da; }
.export_time_opera_type.blue { color: #0071b6;background-color: #e0f1fc; }
</style>
